import { useRef, useState } from "react"

import appStore from "@/stores/appStore"
import EmailMarketingDialog from "./EmailMarketingDialog"
import {
  dismissOrderEmailPrompt,
  dismissRegistrationEmailPrompt,
  hasDismissedOrderEmailPrompt,
  hasDismissedRegistrationEmailPrompt,
} from "./emailMarketingPromptPersistence"

type PromptSource = "registration" | "order" | null

export const useEmailMarketingPrompt = () => {
  const [source, setSource] = useState<PromptSource>(null)
  const afterCloseRef = useRef<(() => void) | undefined>(undefined)

  const hasEmail = Boolean(appStore.userInfo.email)
  const userId = appStore.userInfo.id

  const openRegistrationPrompt = (afterClose?: () => void) => {
    if (hasEmail || hasDismissedRegistrationEmailPrompt(userId)) return false
    afterCloseRef.current = afterClose
    setSource("registration")
    return true
  }

  const openOrderPrompt = (afterClose?: () => void) => {
    if (hasEmail || hasDismissedOrderEmailPrompt(userId)) return false
    afterCloseRef.current = afterClose
    setSource("order")
    return true
  }

  const handleOpenChange = (open: boolean) => {
    if (open) return

    if (source === "registration") dismissRegistrationEmailPrompt(userId)
    if (source === "order") dismissOrderEmailPrompt(userId)
    setSource(null)
    const afterClose = afterCloseRef.current
    afterCloseRef.current = undefined
    afterClose?.()
  }

  return {
    emailMarketingDialog: <EmailMarketingDialog open={source !== null} onOpenChange={handleOpenChange} />,
    openOrderPrompt,
    openRegistrationPrompt,
  }
}
